import React, { useState, useEffect } from 'react';
import { datatypeService } from '../../services';
import { DataTable } from '../../components';
import { useSideDialog, useModalDialog, useGlobalState, useMessage } from '../../hooks';
import { handleError, Role } from '../../helpers';

export const Datatypes = () => {
  const [datatypes, setDatatypes] = useState([]);
  const [loggedInUser, setLoggedInUser] = useGlobalState('loggedInUser');
  const [selectedItems, setSelectedItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const clearSelectedItems = () => {
    setSelectedItems([]);
  };

  const { showMessage } = useMessage();
  const { showSideDialog, hideSideDialog, setSideDialog } = useSideDialog(clearSelectedItems);
  const { showModalDialog, hideModalDialog } = useModalDialog();

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    datatypeService
      .getAll()
      .then(res => {
        setDatatypes(res.datatypes);
        setLoading(false);
      })
      .catch(err => {
        setLoading(false);
        showMessage(err, 'error');
      });
  };

  const addDatatype = async data => {
    const props = { datatypes: [data] };

    await datatypeService
      .create(props)
      .then(res => {
        setSideDialog(prev => ({ ...prev, formErrors: {} }));
        fetchItems();
        showMessage(res.message);
      })
      .catch(err => {
        handleError({ err, showMessage, setSideDialog });
        throw err;
      });
  };

  const editDatatype = async data => {
    const props = { datatypes: Array.isArray(data) ? data : [data] };

    await datatypeService
      .update(props)
      .then(async res => {
        fetchItems();
        showMessage(res.message);
        clearSelectedItems();
        hideSideDialog();
      })
      .catch(err => {
        handleError({ err, showMessage, setSideDialog });
        throw err;
      });
  };

  const deleteDatatype = async data => {
    await datatypeService
      .destroy({ datatypes: data })
      .then(async res => {
        hideModalDialog();
        clearSelectedItems();
        fetchItems();
        showMessage(res.message);
      })
      .catch(err => {
        showMessage(err, 'error');
      });
  };

  const editable = loggedInUser && loggedInUser.user_role_name === Role.admin;

  const booleanValues = {
    true: { label: 'Yes', className: 'pill pill-black' },
    false: { label: 'No', className: 'pill pill-grey' },
  };

  return (
    <DataTable
      columns={[
        { id: 'datatype_category', name: '', type: 'icon' },
        { id: 'datatype_name', name: 'Name', className: 'bold' },
        { id: 'datatype_category', name: 'Category', className: 'small-text' },
        { id: 'has_length', name: 'Length', type: 'boolean', values: booleanValues },
        { id: 'has_precision', name: 'Precision', type: 'boolean', values: booleanValues },
        { id: 'has_scale', name: 'Scale', type: 'boolean', values: booleanValues },
        { id: 'has_children', name: 'Nestable', type: 'boolean', values: booleanValues },
      ]}
      buttons={[
        {
          label: '+ Add',
          action: 'add',
          mainButton: true,
          onClick: items => showSideDialog('addDatatype', items || selectedItems, addDatatype),
        },
        {
          label: 'Edit',
          action: 'edit',
          onClick: items => showSideDialog('editDatatype', items || selectedItems, editDatatype),
        },
        {
          label: 'Delete',
          action: 'delete',
          onClick: items =>
            showModalDialog('deleteDatatype', items || selectedItems, deleteDatatype),
        },
      ]}
      data={datatypes}
      idColumn="datatype_id"
      selectedItems={selectedItems}
      setSelectedItems={setSelectedItems}
      loading={loading}
      filterable={true}
      filterObjects={[
        'datatype_name',
        'datatype_category',
        'has_length',
        'has_precision',
        'has_scale',
        'has_children',
      ]}
    />
  );
};
